import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/data-quality/")({
  beforeLoad: () => {
    throw redirect({ to: "/data-quality/rules" });
  },
});
